import { Link, useLocation, useNavigate } from "react-router-dom";

const FooterLink = ({ target, testId, children }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const go = () => {
    const el = document.getElementById(target);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    } else if (pathname !== "/") {
      navigate(`/#${target}`);
    }
  };
  return (
    <li>
      <button
        onClick={go}
        className="hover:text-white transition-colors duration-300"
        data-testid={testId}
      >
        {children}
      </button>
    </li>
  );
};

export const Footer = () => (
  <footer className="bg-[#241813]" data-testid="main-footer">
    <div className="max-w-7xl mx-auto px-6 sm:px-10 pt-20 pb-10">
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-12 pb-14 border-b border-white/10">
        <div>
          <p className="font-serif-display text-3xl tracking-[0.2em] text-white" data-testid="footer-brand">CELUSTA</p>
          <p className="mt-4 text-sm font-light leading-relaxed text-[#D9CCC0] max-w-xs" data-testid="footer-description">
            Thoughtful essentials for hair, body and everyday beauty.
          </p>
        </div>
        <div>
          <p className="font-mono-accent text-[11px] uppercase tracking-[0.2em] text-[#C9A45C] mb-5">Shop</p>
          <ul className="space-y-3 text-sm font-light text-[#D9CCC0]">
            <FooterLink target="essentials" testId="footer-all-products-link">All Products</FooterLink>
            <FooterLink target="shop" testId="footer-hair-link">Hair Care</FooterLink>
            <FooterLink target="body-care" testId="footer-body-link">Body Care</FooterLink>
            <FooterLink target="ingredients" testId="footer-ingredients-link">Ingredients</FooterLink>
            <FooterLink target="faq" testId="footer-faq-link">FAQ</FooterLink>
          </ul>
        </div>
        <div>
          <p className="font-mono-accent text-[11px] uppercase tracking-[0.2em] text-[#C9A45C] mb-5">Customer Care</p>
          <ul className="space-y-3 text-sm font-light text-[#D9CCC0]">
            <li>
              <a
                href="mailto:info@celusta.com"
                className="hover:text-white transition-colors duration-300"
                data-testid="footer-contact-link"
              >
                Contact Us
              </a>
            </li>
            <li>
              <Link to="/shipping" className="hover:text-white transition-colors duration-300" data-testid="footer-shipping-link">
                Shipping &amp; Delivery
              </Link>
            </li>
            <li>
              <Link to="/returns" className="hover:text-white transition-colors duration-300" data-testid="footer-returns-link">
                Returns &amp; Refunds
              </Link>
            </li>
            <li>
              <Link to="/privacy" className="hover:text-white transition-colors duration-300" data-testid="footer-privacy-link">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms" className="hover:text-white transition-colors duration-300" data-testid="footer-terms-link">
                Terms of Service
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <p className="font-mono-accent text-[11px] uppercase tracking-[0.2em] text-[#C9A45C] mb-5">Contact</p>
          <p className="text-sm font-light leading-relaxed text-[#D9CCC0]">Questions? We're here to help.</p>
          <a
            href="mailto:info@celusta.com"
            className="mt-3 inline-block text-sm font-light text-[#D9CCC0] underline underline-offset-4 decoration-[#C9A45C]/50 hover:text-white transition-colors duration-300"
            data-testid="footer-contact-email"
          >
            info@celusta.com
          </a>
        </div>
      </div>
      <div className="pt-8 flex flex-col sm:flex-row justify-between gap-4" data-testid="footer-legal-row">
        <p className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#9A867A]" data-testid="footer-copyright">
          © {new Date().getFullYear()} CELUSTA. All rights reserved.
        </p>
        <p className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#9A867A]">
          Everyday care, made simple.
        </p>
      </div>
    </div>
  </footer>
);
